import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66f68fe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-page__footer footer nongfu-button-wrap" }

import {} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CommonFooterWrap',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})